import { apiPost } from './http-client';

export type RequestPasswordResetResponse = { detail?: string; message?: string };
export const EMBED_AUTH_PASSWORD_API = {
  requestReset: '/api/v1/auth/request-password-reset',
  completeReset: '/api/v1/auth/complete-password-reset'
} as const;

/** POST /api/v1/auth/request-password-reset */
export function postRequestPasswordReset(body: {
  email: string;
  captcha_token?: string;
}): Promise<RequestPasswordResetResponse> {
  return apiPost<RequestPasswordResetResponse>(EMBED_AUTH_PASSWORD_API.requestReset, body);
}

/** POST /api/v1/auth/complete-password-reset */
export function postCompletePasswordReset(body: {
  token: string;
  new_password: string;
  new_password_confirm: string;
  current_password?: string | null;
  captcha_token?: string;
}): Promise<void> {
  return apiPost<void>(EMBED_AUTH_PASSWORD_API.completeReset, body);
}
